import { calculateYardLine } from "../helpers/distance"
import { GamePlay } from "../model/game-play"
import { Command } from "./Command"

export class SetKickoffYardLineCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private nextGamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND SetKickoffYardLineCommand', this.gamePlay)

    this.nextGamePlay.yardLine = calculateYardLine('-45', this.gamePlay.penYardsKickoff ?? 0)
  }
}
